import React, { useContext } from "react";
import { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import "./Piechart.css";
import { Context } from "../../../../utils/context";
const Piechart = ({ headingText }) => {
  const { postData, getData } = useContext(Context);
  const [data, setData] = useState();
  const [series, setSeries] = useState([]);
  const GetData = async () => {
    const response = await getData(`/masters/app-setup/dashboard/data`);
    setData(response?.data);
    setSeries([
      // response?.data.cancleBookingCount,
      response.data?.completeBookingCount,
    ]);
  };

  useEffect(() => {
    GetData();
  }, []);

  const [options, setOptions] = useState({
    chart: {
      width: 380,
      type: "donut",
    },
    plotOptions: {
      pie: {
        startAngle: -90,
        endAngle: 270,
      },
    },
    dataLabels: {
      enabled: false,
    },
    fill: {
      type: "gradient",
    },
    labels: ["Completed Bookings"],
    legend: {
      formatter: function (val, opts) {
        return val + " - " + opts.w.globals.series[opts.seriesIndex];
      },
    },
    responsive: [
      {
        breakpoint: 1200,
        options: {
          chart: {
            width: 350,
          },
          legend: {
            position: "bottom",
          },
        },
      },
    ],
  });

  return (
    <>
      <div>
        <section className="Piechart">
          <div className="heading-holder">
            <h3>{headingText}</h3>
          </div>
          <div className="chart-holder " id="chart">
            <ReactApexChart
              options={options}
              series={series}
              type="donut"
              width={380}
            />
          </div>
          <div id="html-dist"></div>
        </section>
      </div>
    </>
  );
};

export default Piechart;
